module.exports = __webpack_public_path__ + "static/media/Artboard1.81fdb7f0.png";